/* @flow */
/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import getConfig from 'next/config';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';
import Icon from '../../Icon';

const { assetPrefix } = getConfig().publicRuntimeConfig;

const resources = [
  {
    name: 'Binance',
    iconType: 'exchange',
    fileType: 'PNG',
    url: 'exchange.png',
  },
  {
    name: 'Academy',
    iconType: 'academy',
    fileType: 'PNG',
    url: 'academy.png',
  },
  {
    name: 'BCF',
    iconType: 'bcf',
    fileType: 'PNG',
    url: 'charity.png',
  },
  {
    name: 'Info',
    iconType: 'info',
    fileType: 'PNG',
    url: 'info.png',
  },
  {
    name: 'Labs',
    iconType: 'labs',
    fileType: 'PNG',
    url: 'labs.png',
  },
  {
    name: 'Launchpad',
    iconType: 'launchpad',
    fileType: 'PNG',
    url: 'launchpad.png',
  },
  {
    name: 'Research',
    iconType: 'research',
    fileType: 'PNG',
    url: 'Research.png',
  },
  {
    name: 'Trust Wallet',
    iconType: 'trust-wallet',
    fileType: 'PNG',
    url: 'trust-wallet.png',
  },
];

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 90px 0 144px 0;
  font-family: ${({ theme }) => theme.fontIBMLight};
  background: #fff;
`;
const Content = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
`;
const Title = styled.div`
  font-size: 54px;
  color: #212833;
  font-weight:200;
  padding-bottom: 25px;
`;
const Description = styled.div`
  font-size: 16px;
  color: #48515d;
  font-family: ${({ theme }) => theme.fontIBMMedium};
  > p {
    margin-bottom: 25px;
    > a {
      color: #f0b90b;
    }
  }
  > a {
    color: #212833;
    font-size: 16px;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
`;

const List = styled(FlexBox)`
  width: 100%;
  margin-top: 100px;
`;
const Item = styled.div`
  width: 274px;
  height: 260px;
  padding: 30px 30px 30px 26px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(245, 245, 245, 1);
  border-top: 2px solid rgba(234, 236, 239, 0.8);
  margin-bottom: 55px;
  &:hover {
    transition: all 0.5s;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(246, 246, 246, 1);
    border-top: 2px solid #f0b90b;
    > .iconfont {
      transition: all 0.5s;
      color: #f0b90b;
    }
    > p {
      > a {
        color: #f0b90b;
      }
    }
    &:last-child {
      .icon-trust-wallet {
        color: #3274ba;
      }
    }
  }
  > .iconfont {
    font-size: 46px;
    color: #48515d;
    line-height: 100%;
  }
  > p {
    margin: 117px 0 0 0;
    > div {
      font-size: 14px;
      color: #48515d;
      margin-bottom: 5px;
      font-family: ${({ theme }) => theme.fontIBMMedium};
    }
    > a {
      color: #848e9c;
      font-size: 12px;
      font-family: ${({ theme }) => theme.fontIBMRegular};
      > .iconfont {
        font-size: 12px;
        margin-left: 10px;
      }
    }
  }
`;

type Props = {
  i18n: Object,
};

export default
@withI18n
class Announcements extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
  };

  render() {
    const { i18n } = this.props;

    return (
      <WrapperBox direction="column">
        <Content>
          <Title>{getLabel('exchange-PRResource-mediaAssets', i18n)}</Title>
          <Description>
            <p>
              {getLabel(
                'exchange-PRResource-downloadHere',
                i18n
              )}{' '}
              <a
                id="PR-resource-a-binanceLogoGuidelines"
                href="https://drive.google.com/open?id=15uepCUdrMoQZFze-aGjEaB1xjTrlX2XP"
                target="_blank"
                rel="noopener noreferrer"
              >
                {getLabel('exchange-PRResource-binanceLogoGuidelines', i18n)}
              </a>{' '}
              {getLabel('exchange-PRResource-beforeUse', i18n)}
              <br />
              {getLabel(
                'exchange-PRResource-lookingFor',
                i18n
              )}
            </p>
            <a
              id="PR-resource-a-visit"
              href="https://drive.google.com/open?id=1ZHKL9aCT9JEA7Gaj7sXsnpe8QJHvM6bi"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-PRResource-visit', i18n)} {'>>'}
            </a>
          </Description>
          <List justify="space-between">
            {resources.map((item, i) => (
              <Item key={i}>
                <Icon type={item.iconType} />
                <p>
                  <div>{item.name}</div>
                  <a
                    id={`PR-resource-a-${i+1}`}
                    href={`${assetPrefix}/static/images/press-icon/${item.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.fileType} <Icon type="xiazai1" />
                  </a>
                </p>
              </Item>
            ))}
          </List>
        </Content>
      </WrapperBox>
    );
  }
}
